import { render } from "./MeetingRoomsModule.vue?vue&type=template&id=e83c4106&scoped=true"
import script from "./MeetingRoomsModule.vue?vue&type=script&lang=js"
export * from "./MeetingRoomsModule.vue?vue&type=script&lang=js"

import "./MeetingRoomsModule.vue?vue&type=style&index=0&id=e83c4106&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e83c4106"

export default script